import { Styled } from './';
import React from 'react';
import { Button } from 'components/core';
import { ReloadProps } from './';

export const Reload = ({ productList }: ReloadProps) => {
  return (
    <Styled.ReloadMessageContainer>
      <Styled.ReloadMessage>
        <p>Please refresh the page to reload the products..</p>
        <div>
          <Button
            variant="primary"
            onClick={() => {
              productList.refetch();
            }}
            width={'30%'}
            loading={productList.isRefetching}
          >
            Refresh
          </Button>
        </div>
      </Styled.ReloadMessage>
    </Styled.ReloadMessageContainer>
  );
};
